import PropTypes from 'prop-types';

const FlagType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  note: PropTypes.string.isRequired,
  suboption: PropTypes.string,
  user_name: PropTypes.string.isRequired,
  created_at: PropTypes.string, // TODO add timestamp type
});

export default FlagType;



// WEBPACK FOOTER //
// ./client/app/shared/types/flag.js